/* @flow */
// Phones: while the live chat is open it covers the lower part of the screen.
// A tap on the player above it closes the chat (and does nothing else, so a
// stray tap doesn't also skip a song).
const isOpen = () => {
  try {
    return document.documentElement.classList.contains('hs-messages-widget-open')
  } catch (e) {
    return false
  }
}

export const setUpChatPanel = () => {
  try {
    if (!window.matchMedia || !window.matchMedia('(max-width: 767px)').matches) return
    document.addEventListener('click', (ev: any) => {
      if (!isOpen()) return
      const box = document.getElementById('hubspot-messages-iframe-container')
      if (box && ev.target && box.contains(ev.target)) return
      const w = window.HubSpotConversations && window.HubSpotConversations.widget
      if (!w || typeof w.close !== 'function') return
      ev.preventDefault()
      ev.stopPropagation()
      w.close()
    }, true)
  } catch (e) {}
}

// Phones: while typing in a field (timetable link, Ad Studio text...), hide the
// play bar and the chat bubble so they don't sit on top of the keyboard and
// cover what you're typing.
export const setUpTypingMode = () => {
  try {
    if (!window.matchMedia || !window.matchMedia('(max-width: 767px)').matches) return
    const isField = (el: any) => el && (el.tagName === 'TEXTAREA' ||
      (el.tagName === 'INPUT' && ['text', 'url', 'email', 'search', 'tel', 'number', 'password'].indexOf(el.type) >= 0) ||
      el.isContentEditable)
    const root = document.documentElement
    document.addEventListener('focusin', (ev: any) => {
      if (root && isField(ev.target)) root.classList.add('gr-typing')
    })
    document.addEventListener('focusout', () => {
      setTimeout(() => {
        if (root && !isField(document.activeElement)) root.classList.remove('gr-typing')
      }, 100)
    })
  } catch (e) {}
}
